<fgb-game-card-countdown [game]="nextGame$ | async"></fgb-game-card-countdown>
